import z from "zod";
import { TipPresetButtonType } from "./enums/TipPresetButtonType";

const TipPresetGridLayoutScheme = z.object({
  gridCol: z.number().int().min(0).max(31),
  gridRow: z.number().int().min(0).max(31),
  colSpan: z.number().int().min(1).max(32),
  rowSpan: z.number().int().min(1).max(32),
});

const TipPresetButtonPercentageScheme = TipPresetGridLayoutScheme.extend({
  type: z.literal(TipPresetButtonType.PERCENTAGE),
  percentage: z.number(),
});

const TipPresetButtonFixedAmountScheme = TipPresetGridLayoutScheme.extend({
  type: z.literal(TipPresetButtonType.FIXED_AMOUNT),
  amount: z.number(),
});

const TipPresetButtonEnterAmountScheme = TipPresetGridLayoutScheme.extend({
  type: z.literal(TipPresetButtonType.ENTER_AMOUNT),
});

const TipPresetButtonNoTipScheme = TipPresetGridLayoutScheme.extend({
  type: z.literal(TipPresetButtonType.NO_TIP),
});

export const TipPresetButtonScheme = z.discriminatedUnion("type", [
  TipPresetButtonPercentageScheme,
  TipPresetButtonFixedAmountScheme,
  TipPresetButtonEnterAmountScheme,
  TipPresetButtonNoTipScheme,
]);

export const TipPresetButtonsScheme = z.array(TipPresetButtonScheme);

export type TipPresetButton = z.infer<typeof TipPresetButtonScheme>;
